<!-- <app-header></app-header> -->
<router-outlet></router-outlet>

<app-toasts aria-live="polite" aria-atomic="true"></app-toasts>
<div id="attractions" class="container my-5">
    <div class="row">
        <!-- Left Side -->
        <div class="col-md-5 col-12 mb-4 d-flex align-items-center justify-content-center flex-column text-center">
            <h1 class="explore-heading">EXPLORE</h1>
            <h1 class="explore-subheading">THE CITY</h1>
            <p class="description">
                Our knowledgeable concierge team can assist you in planning your itinerary and arranging tours, tickets, and transportation.
            </p>
            <a (click)="scrollToSection('location')" class="contact-button btn btn-primary">Contact Us</a>
        </div>

        <!-- Right Side (Grid of Images) -->
        <!-- {{this.token?.getProperty()?.address?.city}} -->
        <div class="col-md-7 col-12">
          <main *ngIf="blogPosts$ | async as blogPosts">
            <div *ngFor="let blogPost of blogPosts.items; let i = index">
            <div class="row" >
              <ng-container *ngFor="let item of blogPost.fields.citiesimages; let j = index">
              <div  class="col-md-6 col-12 mb-4" *ngIf="j < 4 && blogPost.fields.title === this.tokenStorage?.getProperty()?.address?.city">

                  <div *ngIf="blogPost.fields.title === this.tokenStorage?.getProperty()?.address?.city ">

                      <div class="card" style="z-index: 1; margin-bottom: -40px; border-radius: 15px;">
                        <img [src]="item.fields.file.url" class="card-img-top" style="border-radius: 15px;height:200px" alt="This Temple">
                      </div>
                      <div class="card-body text-center card-body-style" style="background-color: var(--primary) !important; margin-left: -10px; margin-right: -10px; border-radius: 10px; padding-top: 50px;">
                        <h5 class="card-title">{{ item.fields.title }}</h5>
                      </div>

                  </div>

              </div>
              </ng-container >
            </div>

          </div>
          </main>
        </div>


            </div>
</div>

<div class="nearby-places-section">
  <h2 class="section-heading">Nearby Places</h2>
  <div class="unique-cards-container d-none d-md-flex">
    <div class="card unique-card">
      <img src="assets/images/Bhor Ghat.webp" class="card-img-top" alt="Bhor Ghat">
      <div class="card-body">
        <p class="card-text">Bhor Ghat</p>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Blackwaters of Pali Bhutivali Dam.jpg" class="card-img-top" alt="Blackwaters of Pali Bhutivali Dam">
      <div class="card-body">
        <p class="card-text">Blackwaters of Pali Bhutivali Dam</p>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/hq720.jpg" class="card-img-top" alt="Jain Temple">
      <div class="card-body">
        <p class="card-text">Jain Temple</p>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Kothaligad.avif" class="card-img-top" alt="Kothaligad">
      <div class="card-body">
        <p class="card-text">Kothaligad</p>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/ND Studio Karjat.jpg" class="card-img-top" alt="ND Studio Karjat">
      <div class="card-body">
        <p class="card-text">ND Studio Karjat</p>
      </div>
    </div>
  </div>
</div>




<div class="unique-carousel-wrapper d-block d-md-none">
  <h2 class="section-heading">Nearby Places</h2>
  <div class="unique-carousel-card shadow-lg border-0 rounded overflow-hidden">
    <div id="carouselExampleControls" class="carousel slide" data-ride="carousel">
      <div class="carousel-inner unique-carousel-inner">
        <!-- Loop through the items using Angular's *ngFor -->
        <div
          *ngFor="let item of carouselItems; let i = index"
          class="carousel-item"
          [ngClass]="{ 'active': i === 0 }"
        >
          <div class="unique-carousel-item-content text-center p-3">
            <div class="unique-carousel-item-card">
              <img [src]="item.imgSrc" [alt]="item.title" class="img-fluid circular-image">
              <h2 class="mt-3">{{ item.title }}</h2>
              <p>{{ item.age }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Carousel Controls -->
      <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>
    </div>
  </div>
</div>









<div class="container my-5">
  <div class="row" id="testimonials">
    <!-- First Column -->
    <div class="col-md-4 mb-4 d-flex flex-column justify-content-center align-items-start">
      <h2 class="headline font-weight-bold mb-3">Real Stays, Real Talk</h2>
      <p class="intro-text mb-4 text-muted">Here's what our guests are saying...</p>
      <a href="https://search.google.com/local/writereview?placeid=ChIJO_Xdfxv75zsRqRmS0zQUWiE" class="btn btn-primary btn-lg writereview">
      <div style="padding-left: 10px;padding-right: 10px;">
        Write a Review
      </div>
    </a>
    </div>
    <!-- Second Column (Carousel for Desktop) -->
    <div class="col-md-8 mb-4 d-md-block">
      <div class="carousel-controls">
        <a href="#carouselExampleControlsreview" role="button" data-slide="prev" class="carousel-control-prev">
          <span aria-hidden="true" class="carousel-control-prev-icon"></span>
          <span class="sr-only">Previous</span>
        </a>
        <a href="#carouselExampleControlsreview" role="button" data-slide="next" class="carousel-control-next">
          <span aria-hidden="true" class="carousel-control-next-icon"></span>
          <span class="sr-only">Next</span>
        </a>
      </div>
      <div class="card shadow-sm border-0 h-100">
        <div id="carouselExampleControlsreview" data-ride="carousel" class="carousel slide">
          <div class="carousel-inner style_carasol" style="display: block;">
            
            <div data-interval="10000" class="carousel-item">
              <div class="row">
                <div class="col-md-12 d-flex align-items-center">
                  <div class="testimonial p-3 text-center">
                    <img src="assets/images/user-logo.png" alt="Pranali Dandwate" class="rounded-circle img-fluid shadow-lg mb-3" style="width: 80px; height: 80px;">
                    <h5 class="font-weight-bold mb-1">Pranali Dandwate</h5>
                    <p class="small text-muted mb-2 review-text">Nice farmhouse.
                      We enjoy lot .Very nice ambiance and delicious food, pool is very nice and huge, huge space for dancing, clean and maintained rooms for stay. Overall staff is also nice and kind.</p>
                    <div class="star-ratings text-warning">★★★★★</div>
                  </div>
                </div>
              </div>
            </div>
    
            <div data-interval="10000" class="carousel-item">
              <div class="row">
                <div class="col-md-12 d-flex align-items-center">
                  <div class="testimonial p-3 text-center">
                    <img src="assets/images/user-logo.png" alt="nitin meshram" class="rounded-circle img-fluid shadow-lg mb-3" style="width: 80px; height: 80px;">
                    <h5 class="font-weight-bold mb-1">nitin meshram</h5>
                    <p class="small text-muted mb-2 review-text">It's a good place for large groups, large areas with a big swimming pool and rain dance, lawn, indoor games and delicious food. The packages they offer is also less as compared to other places in karjat. Service and rooms are good.</p>
                    <div class="star-ratings text-warning">★★★★</div>
                  </div>
                </div>
              </div>
            </div>
    
            <div data-interval="10000" class="carousel-item active carousel-item-left">
              <div class="row">
                <div class="col-md-12 d-flex align-items-center">
                  <div class="testimonial p-3 text-center">
                    <img src="assets/images/user-logo.png" alt="ruchira deshmukh" class="rounded-circle img-fluid shadow-lg mb-3" style="width: 80px; height: 80px;">
                    <h5 class="font-weight-bold mb-1">ruchira deshmukh</h5>
                    <p class="small text-muted mb-2 review-text">Very nice cozy place to chill with friends and family, good food, good sleeping rooms, staf is friendly, big swimming pool with clean water , nice space for dancing and partying, highly recommend</p>
                    <div class="star-ratings text-warning">★★★★★</div>
                  </div>
                </div>
              </div>
            </div>
    
            <div data-interval="10000" class="carousel-item carousel-item-next carousel-item-left">
              <div class="row">
                <div class="col-md-12 d-flex align-items-center">
                  <div class="testimonial p-3 text-center">
                    <img src="assets/images/user-logo.png" alt="Hemant Doke" class="rounded-circle img-fluid shadow-lg mb-3" style="width: 80px; height: 80px;">
                    <h5 class="font-weight-bold mb-1">Hemant Doke</h5>
                    <p class="small text-muted mb-2 review-text">Peace ful place, open place for playing cricket and other games, delicious food,big swimming pool Which makes our group relax and we enjoy alot there even In night we played different games in garden area Thanks for making our those 2 days enjoyable.</p>
                    <div class="star-ratings text-warning">★★★★★</div>
                  </div>
                </div>
              </div>
            </div>
    
            <div data-interval="10000" class="carousel-item">
              <div class="row">
                <div class="col-md-12 d-flex align-items-center">
                  <div class="testimonial p-3 text-center">
                    <img src="assets/images/user-logo.png" alt="Rupam Sawardekar" class="rounded-circle img-fluid shadow-lg mb-3" style="width: 80px; height: 80px;">
                    <h5 class="font-weight-bold mb-1">Rupam Sawardekar</h5>
                    <p class="small text-muted mb-2 review-text">Very nice ambiance and good food, pool is very nice and huge, huge space for dancing, clean and maintained rooms for stay.</p>
                    <div class="star-ratings text-warning">★★★★★</div>
                  </div>
                </div>
              </div>
            </div>
    
            <div data-interval="10000" class="carousel-item">
              <div class="row">
                <div class="col-md-12 d-flex align-items-center">
                  <div class="testimonial p-3 text-center">
                    <img src="assets/images/user-logo.png" alt="Pratik Sonawane" class="rounded-circle img-fluid shadow-lg mb-3" style="width: 80px; height: 80px;">
                    <h5 class="font-weight-bold mb-1">Pratik Sonawane</h5>
                    <p class="small text-muted mb-2 review-text">Room amenities are much clean and safe for couples, families friends Food iss delicious 🤤 Behaviour of caretaker is brilliant .. Like This farmhouse very well 🫶</p>
                    <div class="star-ratings text-warning">★★★★★</div>
                  </div>
                </div>
              </div>
            </div>

            <div data-interval="10000" class="carousel-item">
              <div class="row">
                <div class="col-md-12 d-flex align-items-center">
                  <div class="testimonial p-3 text-center">
                    <img src="assets/images/user-logo.png" alt=" Sneha Gupta" class="rounded-circle img-fluid shadow-lg mb-3" style="width: 80px; height: 80px;">
                    <h5 class="font-weight-bold mb-1"> Sneha Gupta</h5>
                    <p class="small text-muted mb-2 review-text">I love the Greenery around the farm, It was very good experience of mine, so peaceful, Flowerful. I personally love it.</p>
                    <div class="star-ratings text-warning">★★★★</div>
                  </div>
                </div>
              </div>
            </div>

            <div data-interval="10000" class="carousel-item">
              <div class="row">
                <div class="col-md-12 d-flex align-items-center">
                  <div class="testimonial p-3 text-center">
                    <img src="assets/images/user-logo.png" alt="Aakanksha Gujar" class="rounded-circle img-fluid shadow-lg mb-3" style="width: 80px; height: 80px;">
                    <h5 class="font-weight-bold mb-1">Aakanksha Gujar</h5>
                    <p class="small text-muted mb-2 review-text">Great experience at Sundar farms.....Enjoyed too much with friends.....Must go place for staycation with friends and family!!💫✨️</p>
                    <div class="star-ratings text-warning">★★★★★</div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>






  <div id="location" style="margin-bottom: 2px;">
  <div style="position: relative; width: 100%; max-width: 100%; height: 600px;">
    <!-- The iframe -->
    <iframe src="https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d120760.48903185627!2d73.25639577668584!3d18.941780707170974!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x3be7fb1b7fddf53b%3A0x215a1434d39219a9!2sPosari%2C%20Karjat%2C%20Maharashtra%20410201!3m2!1d18.9417989!2d73.3387975!5e0!3m2!1sen!2sin!4v1728471101824!5m2!1sen!2sin" width="100%" height="100%" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        <div   class="card" style="position: absolute; top: 50px; text-align: center; left: 50px; background-color: white; border-bottom-left-radius: 61px;box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    border-top-right-radius: 59px;
    padding: 50px;">
        <h3>Make Unforgettable Memories</h3>
        <p>We're here to assist you with any questions, requests, or bookings.<br> Please don't hesitate to reach out to us.</p>
        <button class="book-btn" (click)="navigate()">Book Your Stay</button>
        <p class="contact-footer">
          <i class="fa fa-phone"></i> {{property?.mobile}}
        </p>
        <p class="contact-footer">
          <i class="fa fa-envelope"></i> {{property?.email}}
        </p>

      </div>

  </div>
</div>
<!-- Dialogflow Messenger Integration -->

<df-messenger project-id="impactful-name-306810" agent-id="8bb6c52c-8667-4a24-a789-4cd78b154c96" intent="WEBSITE" storage-option="none" language-code="en" max-query-length="-1"   >
  <df-messenger-chat-bubble  id="chatbot" chat-subtitle=""></df-messenger-chat-bubble>
</df-messenger>
<a [href]="getWhatsappShareUrl()" class="float" target="_blank" >
  <i class="fa fa-whatsapp my-float"></i>
</a>

<app-footer></app-footer>

